<template>
  <div id="configView">
    <component :is="$route.params.service" />
  </div>
</template>

<script>
import ConfigNotion from "./config/Notion.vue";

export default {
  name: "ConfigView",
  components: {
    notion: ConfigNotion,
  },
};
</script>
